import React, { FC } from 'react';
import { actionIcCheckCircle24px, alertIcError24px } from 'assets/media/icons';
import { MESSAGE_UNIT_TYPE } from 'common/constants/user';
import { Modal, ModalBody } from 'common/components/base/modal';
import Button from 'common/components/base/button';
import Icon from 'common/components/base/icon';
import './MessageUnit.scss';

type MessageUnitProps = {
    isVisible: boolean;
    message: string;
    type: number;
    onClose: () => void;
};

const MessageUnit: FC<MessageUnitProps> = ({ isVisible, message, type, onClose }) => {
    return (
        <Modal show={isVisible}>
            <ModalBody className="popup-body">
                <div className="body-content">
                    {type === MESSAGE_UNIT_TYPE.Success ? (
                        <Icon className="success-icon" src={actionIcCheckCircle24px} />
                    ) : (
                        <Icon className="error-icon" src={alertIcError24px} />
                    )}
                    <div className="message">{message}</div>
                    <Button className="action-button" variant="secondary" onClick={onClose}>
                        Ok
                    </Button>
                </div>
            </ModalBody>
        </Modal>
    );
};
export default MessageUnit;
